import React from 'react';
import { Box, Paper, Typography, Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { withRouter, useHistory } from 'react-router'; // import the react-router-dom components
import TranslatedText from '../../components/atoms/translated_text';
import RegistrationReceivedActions from '../../redux/reducers/registration_received_reducer/actions';
import useStyles from './styles';
import DatatableList from './components/datatable';
import clsx from 'clsx';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import { TableDefaultFetchValues, Translations } from './configuration';
import NavigationConfig from 'navigation/config';
import useQuery from 'custom_hooks/useQuery';
import RegistrationReceivedViewModal from './components/datatable/view';
import { getState } from 'redux/store';
import { ReducerKeys } from 'redux/reducers';

const RegistrationReceivedPage = (props: any) => {
  // console.log('Render RegistrationReceivedPage');
  const dispatch = useDispatch();
  const classes = useStyles();

  const query = useQuery();
  const vat_num = query.get('vat_num');
  const msidCountry = query.get('msidCountry');
  const schemeType = query.get('schemeType');
  const goBack = query.get('goBack') === 'true' ? true : false;
  let searchParams = {
    ...(vat_num && { vat_num }),
    ...(msidCountry && { msidCountry }),
    ...(schemeType && { schemeType }),
  };

  React.useEffect(() => {
    dispatch(RegistrationReceivedActions.fetchMemberStateExcludeCyprusAction());
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(RegistrationReceivedActions.fetchUnreadNotificationCountAction());
  }, [dispatch]);

  React.useEffect(() => {
    const state = getState(ReducerKeys.REGISTRATION_RECEIVED_REDUCER)
      .RegistrationReceivedList.data;
    // console.log(state);
    dispatch(
      RegistrationReceivedActions.fetchRegistrationReceivedListAction({
        sortField:
          state && goBack
            ? state.sorting.sortField
            : TableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY,
        page:
          state && goBack
            ? state.paging.page
            : TableDefaultFetchValues.TABLE_DEFAULT_PAGE,
        pageSize:
          state && goBack
            ? state.paging.pageSize
            : TableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE,
        order:
          state && goBack
            ? state.sorting.order
            : TableDefaultFetchValues.TABLE_DEFAULT_ORDER,
        ...searchParams,
      })
    );
  }, [dispatch, searchParams]);

  return (
    <div>
      <RegistrationReceivedViewModal />
      <Paper
        className={clsx(classes.titleLayout)}
        elevation={0}
        variant={'outlined'}
        square
      >
        <Box display="flex" alignItems={'center'}>
          <AssignmentOutlinedIcon style={{ marginRight: '.75rem' }} />
          <Typography component={'p'} variant={'h6'}>
            <TranslatedText
              textMap={Translations.page_title}
              defaultText={Translations.page_title.English}
            />
          </Typography>
        </Box>
      </Paper>

      {/*================== RegistrationReceived Page - Body ==================*/}
      <div style={{ padding: 12 }}>
        {/*================== RegistrationReceived Page - Body - RegistrationReceived Section ==================*/}
        <div className={classes.cardLayout}>
          {/* RegistrationReceived Page - Body - RegistrationReceived Section - Title */}
          <Typography
            component={'p'}
            variant={'h5'}
            style={{ marginBottom: '.5rem' }}
          >
            <TranslatedText
              textMap={Translations.title}
              defaultText={Translations.title.English}
            />
          </Typography>

          {/* RegistrationReceived Page - Body - RegistrationReceived Section - Description */}
          <Typography component={'p'} variant={'subtitle1'}>
            <TranslatedText
              textMap={Translations.description}
              defaultText={Translations.description.English}
            />
          </Typography>
          <div className={classes.tableList}>
            <DatatableList />
          </div>

          {/* RegistrationReceived Page - Body - RegistrationReceived Section - Buttons & Actions */}
          <Box display="flex" justifyContent="flex-end">
            <div className={classes.dashboardButton}>
              <BackToDashboardPage />
            </div>
          </Box>
        </div>
      </div>
    </div>
  );
};

const BackToDashboardPage = () => {
  const history = useHistory();
  const goToDashboard = () => {
    history.push(NavigationConfig.dashboardPage().path);
  };

  return (
    <Button
      variant="contained"
      style={{ color: '#e6e6e6', backgroundColor: '#25262d' }}
      onClick={goToDashboard}
    >
      <TranslatedText textMap={Translations.go_to_dashboard} />
    </Button>
  );
};

export default withRouter(RegistrationReceivedPage);
